import { IconButton, CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useRefresh } from 'react-admin';
import { MouseEventHandler, useCallback } from 'react';

export type RefreshIconButtonProps = {
  isFetching?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export const RefreshIconButton = ({
  isFetching,
  onClick: doClick,
}: RefreshIconButtonProps) => {
  const refresh = useRefresh();

  const handleClick: MouseEventHandler<HTMLButtonElement> =
    useCallback(
      e => {
        e.preventDefault();
        e.stopPropagation();

        if (doClick) {
          doClick(e);
        } else {
          refresh();
        }
      },
      [doClick, refresh],
    );

  return (
    <IconButton onClick={handleClick} disabled={!!isFetching}>
      {isFetching ? (
        <CircularProgress size="1.5rem" />
      ) : (
        <RefreshIcon />
      )}
    </IconButton>
  );
};
